import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './plugins/i18n'
import axios from 'axios'
import vuetify from './plugins/vuetify'
import firebaseApp from './plugins/firebase'
import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition'
import './sass/style.sass'

const myTransition = createSimpleTransition('my-transition')
Vue.component('my-transition', myTransition)
Vue.config.productionTip = false
Vue.prototype.$ajax = axios;

new Vue({
  router,
  i18n,
  firebaseApp,
  vuetify,
  render: h => h(App),
  created() {
    document.title = this.$t('app_name');
  },
  data() {
    return {
      api: process.env.VUE_APP_API_HOST,
      explainId: null,
      optimizeId: null,
      optimizeData: null
    }
  }
}).$mount('#app')
